<template>
  <div id="app">
    <!-- 通过v-if来动态的判断展示 -->
    <keep-alive>
      <!-- 这里是会被缓存的视图组件，比如 Home！ -->
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <!-- 这里是不被缓存的视图组件，比如 Edit！ -->
    <router-view v-if="!$route.meta.keepAlive" />
    <!-- <router-view /> -->
  </div>
</template>
<script>
import {
  mapState,
} from 'vuex';

export default {
  computed: {
    ...mapState(['user']),
  },
  mounted() { },

};
</script>

<style lang="less">
.v-modal {
  opacity: unset !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
.el-scrollbar {
  .el-scrollbar__bar {
    opacity: 1 !important;
  }
}
.el-tag {
  width: 80px !important;
  height: 22px !important;
  line-height: 22px !important;
  border-radius: 0 !important;
  text-align: center !important;
}
.el-message {
  z-index: 3010 !important;
}
.new-index {
  z-index: 3001 !important;
}
</style>
